import { forwardRef } from 'react'
import cn from 'clsx'
import type { TSkeletonProps } from './Skeleton.types'
import styles from './Skeleton.module.css'

export const Skeleton = forwardRef<HTMLDivElement, TSkeletonProps>(
    ({ className, ...props }, ref) => (
        <div ref={ref} data-skeleton className={cn(styles.skeleton, className)} {...props} />
    ),
)
